import {
  CheckboxIcon,
  CloseIcon,
} from "@/comps/ai-tools/icons"
import { CustomThemedResource } from "@/comps/image"
import { assetUrl } from "@/utils/cdn"
import clsx from "clsx"
import { useTranslation } from "next-i18next"

export function ReferenceFacePopup() {
  const { t } = useTranslation()

  return (
    <div
      id="reference-face-popup"
      className={clsx(
        "fixed left-0 top-0 z-[101] h-screen w-screen bg-color-popup",
        "items-center justify-center",
      )}
      style={{
        display: "none",
      }}
      onClick={(e) => {
        const target = e.target
        if (target instanceof HTMLElement) {
          if (target.id === "reference-face-popup") {
            closeReferenceFacePopup()
          }
        }
      }}>
      <div
        className={clsx(
          "flex flex-col gap-[10px] rounded-[10px] p-[24px]",
          "relative items-center bg-color-popup-cell desktop:w-[575px]",
        )}
        style={{
          boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.13)",
        }}>
        <p className="text-[18px] font-500 leading-normal text-blue-700">
          {t("txt_face_replace_guide_title")}
        </p>

        <div
          className={clsx(
            "flex w-full gap-[12px] rounded-[10px] desktop:flex-row",
            "flex-col-reverse bg-color-surface p-[8px]",
          )}>
          <div className="flex items-center gap-[12px]">
            {goodPhotos.map((photo) => (
              <div
                key={photo}
                className="relative h-[86px] w-[86px] rounded-lg">
                <img
                  src={assetUrl(photo)}
				  alt="good photos"
                  className="pointer-events-none h-full w-full select-none rounded-lg"
                />
                <div className="absolute left-1 top-1">
                  <CheckboxIcon />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-1 flex-col justify-start gap-2">
            <p className="text-[16px] font-600 leading-normal text-blue-800">
              {t("txt_good_photos")}
            </p>
            <p className="text-[14px] font-400 leading-[18px] text-blue-600">
              {t("txt_make_sure_visible")}
            </p>
          </div>
        </div>

        <div
          className={clsx(
            "flex w-full gap-[12px] rounded-[10px] desktop:flex-row",
            "flex-col-reverse bg-color-surface p-[8px]",
          )}>
          <div className="flex items-center gap-[12px]">
            {badPhotos.map((photo) => (
              <div
                key={photo}
                className="relative h-[86px] w-[86px] rounded-lg">
                <img
                  src={assetUrl(photo)}
				  alt="bad photos"
                  className="pointer-events-none h-full w-full select-none rounded-lg"
                />
                <div className="absolute left-1 top-1">
                  <CloseIcon />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-1 flex-col justify-start gap-2">
            <p className="text-[16px] font-600 leading-normal text-blue-800">
              {t("txt_bad_photos")}
            </p>
            <p className="text-[14px] font-400 leading-[18px] text-blue-600">
              {t("txt_group_pics")}
            </p>
          </div>
        </div>

        <button
          onClick={closeReferenceFacePopup}
          className={clsx(
            "absolute -right-10 top-0 hidden h-8 w-8 items-center",
            "justify-center rounded-full desktop:flex",
            "bg-color-cell transition-colors hover:bg-blue-100",
          )}>
          <CustomThemedResource
            format="svg"
            source="/general/close"
          />
        </button>
      </div>
    </div>
  )
}

function closeReferenceFacePopup() {
  const popup = document.getElementById(
    "reference-face-popup",
  )

  if (popup) {
    popup.style.display = "none"
  }
}

const goodPhotos = [
  "/ai-tools/text-to-image/good-photo-1.webp",
  "/ai-tools/text-to-image/good-photo-2.webp",
  "/ai-tools/text-to-image/good-photo-3.webp",
]

const badPhotos = [
  "/ai-tools/text-to-image/bad-photo-1.webp",
  "/ai-tools/text-to-image/bad-photo-2.webp",
  "/ai-tools/text-to-image/bad-photo-3.webp",
]
